import { Controller } from "@hotwired/stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = [
    "documentNumber",
    "dateEmission",
    "dueDate",
    "documentTypeDescription",
    "percentage",
    "cabysCodes",
    "titleCabysCode"
  ];

  declare documentNumberTarget: HTMLInputElement;
  declare dateEmissionTarget: HTMLInputElement;
  declare dueDateTarget: HTMLInputElement;
  declare documentTypeDescriptionTarget: HTMLInputElement;
  declare percentageTarget: HTMLInputElement;
  declare cabysCodesTarget: HTMLDivElement;
  declare titleCabysCodeTarget: HTMLElement;

  searchExoneration() {
    Rails.ajax({
      type: "get",
      url: `/customers/search_exoneration.json`,
      data: new URLSearchParams({
        document_number: this.documentNumberTarget.value
      }),
      contentType: "application/json",
      success: (data) => {
        this.dateEmissionTarget.value = data.date_emission;
        this.dueDateTarget.value = data.due_date;
        this.documentTypeDescriptionTarget.value =
          data.document_type_description;
        this.percentageTarget.value = data.percentage;
        if (data.cabys_codes) {
          this.changeCabysCodeTitle(data.cabys_codes.length);
          data.cabys_codes.forEach((item) => {
            const span = document.createElement("span");
            span.textContent = item;
            span.classList.add("badge");
            span.classList.add("badge_primary");
            this.cabysCodesTarget.appendChild(span);
          });
        } else {
          // Remove all <span> elements inside the container
          const spans = this.cabysCodesTarget.querySelectorAll("span");
          spans.forEach((span) => span.remove());
          this.changeCabysCodeTitle(0);
        }
      }
    });
  }

  changeCabysCodeTitle(cabysCodesCount) {
    if (this.titleCabysCodeTarget.textContent) {
      this.titleCabysCodeTarget.textContent =
        this.titleCabysCodeTarget.textContent.replace(
          /\(.*?\)/,
          `(${cabysCodesCount})`
        );
      const span = document.createElement("span");
      span.classList.add("collapse-indicator");
      span.classList.add("la");
      span.classList.add("la-arrow-circle-down");
      this.titleCabysCodeTarget.appendChild(span);
    }
  }
}
